import { darken, lighten } from '@mui/material/styles';
import { STATUS_CHIP_COLOR } from 'dashboard409a/pages/Operations/components/constants';

const COMPLETED_DARK_BORDER = '1px solid rgba(0, 0, 0, 0.12)';

export const getStepAccentColors = (
  accentColor: string | undefined,
  isDark: boolean,
  primaryMain: string
) => {
  const activeColor = accentColor ? darken(accentColor, 0.35) : primaryMain;
  const completedBackground =
    accentColor && isDark ? lighten(accentColor, 0.07) : accentColor;

  return {
    activeColor,
    completedBackground,
    completedTextColor: accentColor ? STATUS_CHIP_COLOR : undefined,
    completedDarkBorder: isDark && accentColor ? COMPLETED_DARK_BORDER : undefined,
  };
};
